import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { getDataNatcomNtm } from "../../../redux/Future/Natcom/action";
import Overview from "./Overview";
import Details from "./Detail";
import Compare from "./Compare";
import styled from "styled-components";
import Breadcrumbs from "../../components/Breadcrumbs";
import { Tabs } from "antd";

export default function Ntm() {
  const dispatch = useDispatch();
  const [tabActive, setTabActive] = useState("1");

  const handleGetData = (startDate, endDate) => {
    const url = `/api/get-data-ntm-natcom?startDate=${startDate}&endDate=${endDate}`;
    dispatch(getDataNatcomNtm(url));
  };

  const items = [
    {
      key: "1",
      label: "Overview",
      children: (
        <Overview handleGetData={handleGetData} tabActive={tabActive} />
      ),
    },
    {
      key: "2",
      label: "Details",
      children: <Details handleGetData={handleGetData} tabActive={tabActive} />,
    },
    {
      key: "3",
      label: "Compare",
      children: <Compare handleGetData={handleGetData} tabActive={tabActive} />,
    },
  ];

  const onChangeTabs = (key) => {
    setTabActive(key);
  };
  return (
    <Container>
      <Breadcrumbs data={["Natcom", "Ntm"]} />
      <div className="container-dashboard">
        <Tabs defaultActiveKey="1" items={items} onChange={onChangeTabs} />
      </div>
    </Container>
  );
}
const Container = styled.div`
  .ant-tabs-tab {
    font-size: 15px;
    padding: 5px 20px;
  }
`;
